module.exports = __webpack_public_path__ + "static/customer-journey-a3ef9eb03dc36e167e69d595a0cead77.svg";